import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Typography } from '@deeptrue-frontend/ui';
import { Button } from '@deeptrue-frontend/ui';
import styled from 'styled-components/macro';

import { ProductsCardsProps } from './ProductsCards.types';
import useStyles from './ProductsCards.styles';
import { useFormatMessage } from 'components/IntlProvider';

const StyledButtonsContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 1rem;
`;

const ProductsCards = ({ products, onClick, language }: ProductsCardsProps) => {
  const classes = useStyles();
  const t = useFormatMessage();

  const onClickHandler = (slug: string) =>
    onClick ? onClick(slug) : undefined;

  return (
    <>
      {products.map(({ slug, name, workbench }) => {
        return (
          <Card key={slug} id={slug} className={`${classes.card} product-card`}>
            <CardContent>
              <Typography data-testid={name} variant="subheading">
                {name}
              </Typography>
              <Typography
                data-testid={workbench?.name}
                variant="paragraph"
                mt="0.5rem"
              >
                {workbench?.name}
              </Typography>
              <Typography variant="paragraph" mt="1.5rem">
                {t(`dashboard.workbenches.productDescription.${slug}`, ' ')}
              </Typography>
              <StyledButtonsContainer>
                <Button
                  variant="secondary"
                  style={{ borderColor: '#E3E5E8', margin: '0.5rem' }}
                  onClick={() => onClickHandler(slug)}
                  data-testid={`${slug}_set-up-button`}
                >
                  {t('dashboard.workbenches.setup', 'Set up project')}
                </Button>
              </StyledButtonsContainer>
            </CardContent>
          </Card>
        );
      })}
    </>
  );
};

export default ProductsCards;
